import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurrencyComponent } from '../../../../../shared/components/price/currency.component';
import { SessionRepository } from '../../../../../shared/repositories/session.repository';
import { Observable, shareReplay } from 'rxjs';
import { PriceCurrencyPipe } from '../../../../../shared/pipes/priceCurrency/price-currency.pipe';
import { Currency } from '../../../../../api/v1/models/currency';
import { ConfigRepository } from '../../../../../shared/repositories/config.repository';
import { CostRule } from '../../../../../api/v1/models/cost-rule';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StatusState } from '@ngneat/elf-requests';

@Component({
  selector: 'app-minimal-price-message',
  standalone: true,
  imports: [CommonModule, CurrencyComponent, PriceCurrencyPipe, MatProgressSpinnerModule],
  templateUrl: './minimal-price-message.component.html',
  styleUrls: ['./minimal-price-message.component.scss']
})
export class MinimalPriceMessageComponent {
  constructor(
    private sessionRepository: SessionRepository,
    private configRepository: ConfigRepository,
  ) {}

  currency$: Observable<Currency | null> = this.configRepository.currency$;
  locale$: Observable<string | undefined | null> = this.configRepository.locale$;

  minimalPriceDeliveryMessage: string = $localize`:@@MinimalPriceDeliveryMessage:You're %minimalPrice% short of the minimum order.`;
  intervalPriceDeliveryMessage: string = $localize`:@@IntervalPriceDeliveryMessage:Get it for %nextDeliveryPrice% if you add %needPrice% more to your order.`;
  intervalFreeDeliveryMessage: string = $localize`:@@IntervalFreeDeliveryMessage:Get it for free if you add %needPrice% more to your order.`;
  freePriceDeliveryMessage: string = $localize`:@@FreePriceDeliveryMessage:Free delivery`;

  minimalOrderPrice$: Observable<number> = this.sessionRepository.minimalOrderPrice$;

  totalPrice$: Observable<number> = this.sessionRepository.totalPrice$;
  actualCostRule$: Observable<CostRule | null> = this.sessionRepository.actualCostRule$;
  nextDeliveryLimit$: Observable<number | null> = this.sessionRepository.nextDeliveryLimit$;
  nextActualCostRule$: Observable<CostRule | null> = this.sessionRepository.nextActualCostRule$;

  isBasketProcessing$: Observable<StatusState> = this.sessionRepository.isBasketProcessing$.pipe(
    shareReplay({ refCount: true, bufferSize: 1 })
  );
}
